"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const ProgressCircle = ({ caption, color, size, subtitle, value = 0, ...rest }) => {
    return (react_1.default.createElement(index_1.Box, { display: 'flex', padding: 2 },
        react_1.default.createElement(index_1.Box, { sx: {
                position: 'relative',
                display: 'inline-flex',
                marginRight: 2,
                marginBottom: 'auto',
                marginTop: 'auto',
            } },
            react_1.default.createElement(index_1.CircularProgress, { color: color, size: size, variant: "determinate", value: value, ...rest }),
            react_1.default.createElement(index_1.Box, { sx: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                react_1.default.createElement(index_1.Typography, { variant: "body2" }, `${Math.round(value)}%`))),
        react_1.default.createElement(index_1.Box, { sx: { marginTop: 'auto', marginBottom: 'auto' } },
            react_1.default.createElement(index_1.Typography, { variant: "subtitle1" }, subtitle),
            react_1.default.createElement(index_1.Typography, { variant: "caption", color: "text.secondary" }, caption))));
};
exports.default = ProgressCircle;
